import { request } from '@/network/axios'

import { Benefit, User } from './types'

enum APIS {
  GET_USER_INFO_URL = '/v1/user/current',
}

export const getUserInfo = async (params: any) => {
  const res = await request.get<{
    user: User
    benefit: Benefit
  }>(APIS.GET_USER_INFO_URL, params)
  return res
}
